
import { Options, Vue } from 'vue-class-component'
import { mapGetters } from 'vuex'
import { reactive, getCurrentInstance } from 'vue'
import { getData } from '../utils/nativeFn'
import { registerFnHandler } from '../utils/registerFnHandler'

@Options({
  components: {},
  computed: {
    ...mapGetters(['questionIds'])
  }
})
export default class Home extends Vue {
  // mounted() {
  //   // 前端注册方法供app调用
  //   registerFnHandler("test-dsbirdge", (data) => {
  //     console.log("端上调用1", data); // app返回给前端的值
  //     return "sendData";
  //   });
  //   // 前端调用app注册的方法
  //   setTimeout(() => {
  //     getData("88888", (res) => {
  //       console.log("h5调用端上", res); // app返回给前端的值
  //     });
  //   }, 3000);
  // }
}
